import { getUser } from '@frontend/auth-helpers';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { BaseFieldProps, Modal, Text, TextareaField } from '@frontend/design-system';

export const PromptModal = ({
  onClick,
  onClose,
  promptProps,
}: {
  onClick: () => void;
  onClose: () => void;
  promptProps: BaseFieldProps<string>;
}) => {
  const { t } = useTranslation('email-composer');
  const user = getUser();
  const firstName = user?.firstName ?? '';

  return (
    <>
      <Modal.Header onClose={onClose}>
        <Text css={{ fontSize: theme.font.size.h2 }}>
          {firstName ? t('Hello {{firstName}}!', { firstName: firstName }) : t('Hello!')}
        </Text>
      </Modal.Header>
      <Modal.Body>
        <Text>{t('I can help you create a great email.')}</Text>
        <Text css={{ marginBottom: theme.spacing(1) }}>
          {t('Please write some ideas, topics, and details that you would like included in your email.')}
        </Text>
        <TextareaField {...promptProps} name='prompt' label='' placeholder={t('Type Something...')} />
      </Modal.Body>
      <Modal.Actions
        secondaryLabel={t('Cancel')}
        onSecondaryClick={onClose}
        primaryLabel={t('Continue')}
        disablePrimary={!promptProps.value}
        onPrimaryClick={onClick}
      />
    </>
  );
};
